import { render, staticRenderFns } from "./jcXmList.vue?vue&type=template&id=553be22f&"
import script from "./jcXmList.vue?vue&type=script&lang=js&"
export * from "./jcXmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports